/*global ajaxurl */
import axios from 'axios';
import Qs from 'qs';
import Glide from '@glidejs/glide';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Header animation
    $(window).on('load scroll', function() {
      if ($(this).scrollTop() > 200) {
        $('header.banner').addClass('reduced');
      } else {
        $('header.banner').removeClass('reduced');
      }
    });

    // Appeal Menu button functionality
    $(document).ready(function () {
      var pathname = window.location.href;
      // Remove origin from url
      var pathnameSplit = pathname.split(window.location.origin);
      pathnameSplit = pathnameSplit[1].split('/');
      console.log(pathnameSplit[2]);
      if (pathnameSplit[1] == 'appeals' ) {
        if (pathnameSplit[2]) {
          $('.appeal-card').addClass('faded');
          // Find button tag
          var buttonTag = pathnameSplit[2].split('-expand');
          $(buttonTag[0]).removeClass('faded');
          $(pathnameSplit[2]).removeClass('hide');
          $(pathnameSplit[2]).addClass('show');
        }
      }
    })


    //Important information Home Page Block

    // Callapsable block functionality for Ambassador & patrons
    $('.expand-table-col-text').click(
      function () {
        const id = $(this).find('a').attr('href');
        if ($(id).length) {
          $('.expand-section').removeClass('active');
          $('.expand-table-col-text').addClass('faded');
          $('.table-row-odd').addClass('row-faded');
          $(id).addClass('active');
          $(this).removeClass('faded');
          $(this).addClass('ambassador-selected');
        } else {
          $('.expand-section').removeClass('active');
          $('.expand-table-col-text').removeClass('faded');
          $('.expand-table-col-text').removeClass('ambassador-selected');
          $('.table-row-odd').removeClass('row-faded');
        }
      }
    );
    // Close button for ambassador expandable sections
    $('.close-button').click(
      function () {
        $('.expand-section').removeClass('active');
        $('.expand-table-col-text').removeClass('faded');
        $('.expand-table-col-text').removeClass('ambassador-selected');
        $('.table-row-odd').removeClass('row-faded');
      }
    );

    $('.patron-card-col').click(
      function () {
        const id = $(this).find('a').attr('href');
        if ($(id).length) {
          $('.expand-section').removeClass('active');
          $('.patron-card-col').addClass('faded');
          $('.table-row-odd').addClass('row-faded');
          $(id).addClass('active');
          $(this).removeClass('faded');
        } else {
          $('.expand-section').removeClass('active');
          $('.patron-card-col').removeClass('faded');
          $('.expand-table-col-text').removeClass('patron-selected');
          $('.table-row-odd').removeClass('row-faded');
        }
      }
    );
    // Close button for patron expandable sections
    $('.close-button').click(
      function () {
        $('.expand-section').removeClass('active');
        $('.patron-card-col').removeClass('faded');
        $('.expand-table-col-text').removeClass('patron-selected');
        $('.table-row-odd').removeClass('row-faded');
      }
    );

    // Appeal Expand Section

    if ($('.appeal-expand-area').length > 0) {
      $('.appeal-card').click(
        function () {
          $('.appeal-card').addClass('faded');
          $(this).removeClass('faded');
          let id = $(this).find('a').attr('href');
          $('.appeal-expand-area').addClass('hide');

          $(id).removeClass('hide');
          $(id).addClass('show');
        }
      );

      $('.appeal-card .appeal-read-more').click(
        function (e) {
          e.preventDefault();
        }
      );
    }

    $('.appeal-close-button').click(
      function () {
        $('.appeal-card').removeClass('faded');
        $('.appeal-expand-area').addClass('hide');
      }
    )

    // Close button for important message block
    $('.important-close-button').click(
      function () {
        $('.important-block-root').addClass('important-hide');
        let now = new Date()
        let expiry = now.setTime(now.getTime() + 24 * 60 * 60 * 1000)
        now.setTime(expiry)
        document.cookie = 'notice=true;expires=' + now.toGMTString() + ';path=/'
      }
    )

    // Close button for important message block
    $('.welsh-notice-close-button').click(
      function () {
        $('.welsh-notice-root').addClass('important-hide');
        let now = new Date()
        let expiry = now.setTime(now.getTime() + 24 * 60 * 60 * 1000)
        now.setTime(expiry)
        document.cookie = 'notice=true;expires=' + now.toGMTString() + ';path=/'
      }
    )

    // Menu
    // Close button for Main Menu
    $('.menu-close-button').click(
      function () {
        console.log('CLICKED');
        // $('.hamburger').removeClass('is-active');
        $('.main-menu').slideUp();
      }
    )

    // Toggle navigaiton
    $(document).on('click', '.open-menu', function(){
      // $(this).addClass('is-active');
      if($(this).hasClass('hamburger--squeeze')){

        $('.main-menu').slideDown();
      }
    });


    // Event search functionality
    $('.event-search-tab').click(
      function () {
        const id = $(this).find('a').attr('href');
        $('.event-search-tab').removeClass('active');
        $('.event-search-tab-content').removeClass('active');
        $('.event-search-tab-content').removeClass('show');
        $('.event-search-tab-content').addClass('hide');
        var backgroundColor = $(this).find('a').css('background-color');

        $('#tab-content').css('background-color', backgroundColor);
        $(id).addClass('active');
        $(id).addClass('show');
        $(this).addClass('active');
      }
    );
    // Filter buttons
    $('.filter-button-location').click(
      function () {
        let filter = $(this).html();

        const data = {
          action: 'get_filtered_events',
          meta_value: filter,
          meta_key: 'Location',
        };

        axios.post(ajaxurl, Qs.stringify(data)).then(response => {
          $('#result-tab').html(response.data.data.events);
        }
        ).catch(error => {
          console.log(error.response)
        }
        );
      }
    );
    // Get events based on event type
    $('.filter-button-type').click(
      function () {
        let term = $(this).html();

        const data = {
          action: 'get_filtered_event_types',
          taxonomy: 'event-types',
          term: term,
        };

        axios.post(ajaxurl, Qs.stringify(data)).then(response => {
          $('#result-tab').html(response.data.data.events);
        }
        ).catch(error => {
          console.log(error.response)
        }
        );
      }
    );

    // Get events based on Date
    $('.filter-button-date').click(
      function () {
        let filter = $(this).html();
        console.log(filter);

        const data = {
          action: 'get_filtered_events',
          meta_value: filter,
          meta_key: 'Start Date',
        };

        axios.post(ajaxurl, Qs.stringify(data)).then(response => {
          $('#result-tab').html(response.data.data.events);
        }
        ).catch(error => {
          console.log(error.response)
        }
        );
      }
    );

    // Get all events button
    $('.view-all-events-button').click(
      function () {

        const data = {
          action: 'get_events',
        };

        axios.post(ajaxurl, Qs.stringify(data)).then(response => {
          $('#result-tab').html(response.data.data.events);
        }
        ).catch(error => {
          console.log(error.response)
        }
        );
      }
    );


    function searchBar(search) {

      const data = {
        action: 'get_search_events',
        search: search,
      };

      axios.post(ajaxurl, Qs.stringify(data)).then(response => {
        $('#result-tab').html(response.data.data.events);
      }
      ).catch(error => {
        console.log(error.response)
      }
      );
    }

    // Search bar functionality
    $('#event-search-button').click(
      function () {

        var search = $('#event-search-bar').val();
        searchBar(search)
      }
    );

    $('#event-search-bar').on('keypress', function (e) {
      var search = $(this).val();
      if (e.which == 13) {
        e.preventDefault();
        searchBar(search)
      }
    });

    // Get News based on news type
    $('.news-filter-button').click(
      function () {
        let term = $(this).html();


        const data = {
          action: 'get_filtered_news_types',
          taxonomy: 'news-types',
          term: term,
        };

        axios.post(ajaxurl, Qs.stringify(data)).then(response => {
          $('#search-results').html(response.data.data.news);
        }
        ).catch(error => {
          console.log(error.response)
        }
        );
      }
    );

    // Get More News articles
    $('.news-load-more').click(
      function () {
        let number_of_posts = $('.news-card-col').length;
        number_of_posts += 8;
        console.log(number_of_posts);

        const data = {
          action: 'get_more_news',
          number_of_posts: number_of_posts,

        };

        axios.post(ajaxurl, Qs.stringify(data)).then(response => {
          $('#search-results').html(response.data.data.news);
        }
        ).catch(error => {
          console.log(error.response)
        }
        );
      }
    );

    // Mailing list sign up
    $('#mailing-sign-up-submit').click(
      function () {
        $('#sign-up-footer').addClass('hide');
        $(this).addClass('hide');
      }
    );

    function updateClipPathImageSize() {
      const bg = new Image();
      bg.src = $('.cover-content').data('src');
      const ratio = Math.max($('.cover-content').width() / bg.width, $('.cover-content').height() / bg.height);
      const width = Math.round(ratio * bg.width);
      const height = Math.round(ratio * bg.height);

      var clipped = document.getElementsByClassName('clipped');
      console.log(clipped[0].offsetLeft);

      $('.clipped').css({ 'background-size': width + 'px ' + height + 'px' });
    }

    if ($('.clip-path').length > 0) {
      $(window).on('load', function () {
        updateClipPathImageSize()
      });

      $(window).on('resize', function () {
        updateClipPathImageSize()
      });
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    function generateBulletsAndMountGlide() {
      var bulletCount = document.querySelectorAll('.glide__slide').length;
      var bulletWrapper = document.getElementsByClassName('glide__bullets');

      for (let index = 0; index < bulletCount; index++) {
        const button = document.createElement('button');
        button.className = 'glide__bullet';
        button.setAttribute('data-glide-dir', '=' + index);

        bulletWrapper[0].appendChild(button);
      }
    }

    // Slider
    if ($('.glide').length > 0) {

      generateBulletsAndMountGlide();

      const sliderInstance = document.getElementsByClassName('slider');
      Object.keys(sliderInstance).forEach(key => {
        new Glide(
          sliderInstance[key],
          {
            type: 'carousel',
            perView: 1,
            focusAt: 'center',
            autoplay: 3500,
          }
        ).mount();
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js